import React, { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import VerifyLogin from "./components/login/VerifyLogin";
import Main from "./Main";
import Dashboard from "./components/Dashboard/Dashboard";
import Segment from "./components/Segment/Segment";
import Sign from "./components/Sign/Sign";
import FormExample from "./components/login/Login";
import axios from "axios";

const App = () => {
  const [change, setChange] = useState("");
  const [personal, setPersonal] = useState([]);
  const [msg, setMsg] = useState('')
  const userCode = sessionStorage.getItem("userCode");
  const URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate()

  const logout = () => {
    sessionStorage.clear();
    localStorage.clear();
    navigate("/");
  };
 

  const getUserStatus = async () => {
    
    try {
   const res =   await axios.post(`${URL}/Application/getStatus`, { userCode: userCode || change  }, { withCredentials: true });
  
  //  console.log(res.status);
  //  if(res.data.result.flag == 1){
    setMsg(res.data.data)
  //  }
    } catch (error) {
      if(error.response.status == 401){
        alert('Your session has been expired please logout and login again....')
        logout()
       }
      console.log("error in get status", error);
    }
  };
  
  

  return (
    <>
    <Routes>
     <Route path="/" element={<FormExample change={change} setChange={setChange} />} />
     <Route path="*" element={<main>NOT FOUND</main>} />

     <Route path="/verify" element={<VerifyLogin change={change} />} />
     <Route path="/main" element={<Main msg={msg} setMsg={setMsg} getUserStatus={getUserStatus}/>}/>
     <Route path="/permanent" element={<Dashboard msg={msg} setMsg={setMsg} getUserStatus={getUserStatus} />}/>
     <Route path="/segment" element={<Segment msg={msg} setMsg={setMsg} getUserStatus={getUserStatus} />}/>
     <Route path="/esign" element={<Sign msg={msg} setMsg={setMsg} getUserStatus={getUserStatus} />}/>
   </Routes>
    </>
  );
};

export default App;
